// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderDefaultResponse {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderDefaultResponse.attributeTypeMap;
    }
}
PharmacyV1CardFinderDefaultResponse.discriminator = undefined;
PharmacyV1CardFinderDefaultResponse.additionalProperties = false;
PharmacyV1CardFinderDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyV1CardFinderDefaultResponseData"
    },
];
//# sourceMappingURL=pharmacyV1CardFinderDefaultResponse.js.map